import moment from "moment";
import { copyShortUrl, parseUrl } from "../utils";
import { FgSwitch } from "./FgSwitch";
import { ChartIcon, CopyIcon, ExternalIcon, QrIcon } from "./Icons";

const ICON_BUTTON = "flex items-center justify-center w-9 h-9 rounded-lg border border-gray-200 hover:bg-gray-50 text-gray-700";

export function FgShortLinkItem({ item, onToggleOpenInApp, onEdit, onDelete, onOpenQr, onOpenStats, onSelectGroup }) {
    const { host, utm } = parseUrl(item.url);

    return (
        <li className="py-4 flex gap-4">
            <div className="shrink-0 w-10 h-10 rounded-full bg-[var(--mainColor200)] text-[var(--mainColor)] font-bold flex items-center justify-center uppercase">
                {host.charAt(0)}
            </div>

            <div className="flex-1 min-w-0 flex flex-col gap-1.5">
                <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                        {item.group &&
                            <button type="button" onClick={() => onSelectGroup(item.group)} title="이 그룹만 보기" className="mb-0.5 inline-flex rounded-full bg-[var(--mainColor100)] px-2 py-0.5 text-[11px] font-semibold text-[var(--mainColor)] hover:bg-[var(--mainColor200)]">
                                {item.group}
                            </button>
                        }
                        {item.title
                            ? <p className="text-[15px] font-bold break-all">{item.title} <span className="ml-1 text-xs font-normal text-gray-400">{host}</span></p>
                            : <p className="text-xs text-gray-500">{host}</p>
                        }
                        <button
                            type="button"
                            onClick={() => copyShortUrl(item.shortUrl)}
                            title="클릭해서 복사"
                            className={`text-left break-all hover:text-[var(--mainColor)] ${item.title ? 'text-sm font-semibold text-gray-600' : 'text-[15px] font-bold'}`}
                        >
                            {item.shortUrl.replace(/^https?:\/\//, '')}
                        </button>
                    </div>
                    <button type="button" onClick={() => onOpenStats(item)} title="클릭 통계" className="shrink-0 text-right rounded-lg px-2 py-1 -mr-2 hover:bg-gray-50">
                        <p className="text-lg font-bold leading-tight">{item.clicks.toLocaleString()}</p>
                        <p className="text-[11px] text-gray-500">클릭 · 통계 ›</p>
                    </button>
                </div>

                <p className="text-xs text-gray-400 truncate" title={item.url}>{item.url}</p>

                {utm.length > 0 &&
                    <div className="flex flex-wrap gap-1">
                        {utm.map(r => (
                            <span key={r.key} title={r.key} className="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] text-gray-600">
                                {r.label} · {r.value}
                            </span>
                        ))}
                    </div>
                }

                <div className="flex flex-wrap items-center gap-2 mt-1">
                    <button type="button" onClick={() => copyShortUrl(item.shortUrl)} className={ICON_BUTTON} aria-label="복사" title="복사"><CopyIcon /></button>
                    <button type="button" onClick={() => onOpenStats(item)} className={ICON_BUTTON} aria-label="클릭 통계" title="클릭 통계"><ChartIcon /></button>
                    <button type="button" onClick={() => onOpenQr(item)} className={ICON_BUTTON} aria-label="QR 코드" title="QR 코드"><QrIcon /></button>
                    <button type="button" onClick={() => onEdit(item)} className={ICON_BUTTON} aria-label="수정" title="수정">
                        <img src="/assets/icons/edit_000000.svg" alt="" className="w-4 h-4 opacity-70" />
                    </button>
                    <a href={item.shortUrl} target="_blank" rel="noreferrer" className={ICON_BUTTON} aria-label="열기" title="열기"><ExternalIcon /></a>
                    <button type="button" onClick={() => onDelete(item)} className={ICON_BUTTON} aria-label="삭제" title="삭제">
                        <img src="/assets/icons/delete_000000.svg" alt="" className="w-4 h-4 opacity-70" />
                    </button>
                    <div className="ml-auto flex items-center gap-2 text-xs text-gray-500">
                        <span>{moment(item.createdAt).format('YYYY.MM.DD')}</span>
                        <span className="text-gray-300">|</span>
                        <span>앱으로 열기</span>
                        <FgSwitch checked={item.openInApp} onChange={() => onToggleOpenInApp(item)} label="앱으로 열기" />
                    </div>
                </div>
            </div>
        </li>
    );
}
